export const ERR_NOT_IMPLEMENTED = "Not implemented";
export const ERR_VIRTUAL_MISSING_CONTAINER = "A container was not provided";
export const ERR_VIRTUAL_NOT_STARTED = "Virtual Screen Reader was not started";
